import { Layout, PtPoints as PtPointsComponent } from "components"
export const PtPoints = () => {
 return (
  <Layout>
   <PtPointsComponent />
  </Layout>
 )
}
